import Schema from '../Schema';

const Shipping = new Schema({
  _id: String,
  // Shipping address name
  label: {
    type: String,
    default: ''
  },
  // User ID
  user: {
    type: String,
    default: ''
  },
  // Full name
  name: {
    type: String,
    default: ''
  },
  // First name
  first_name: {
    type: String,
    default: ''
  },
  // Last name
  last_name: {
    type: String,
    default: ''
  },
  // Country code
  country: {
    type: String,
    default: ''
  },
  // Country name
  country_name: {
    type: String,
    default: ''
  },
  // Address line 1
  line1: {
    type: String,
    default: ''
  },
  // Address line 2
  line2: {
    type: String,
    default: ''
  },
  // City
  city: {
    type: String,
    default: ''
  },
  // State
  state: {
    type: String,
    default: ''
  },
  // Zip code
  zip: {
    type: String,
    default: ''
  },
  // Telephone number
  tel: {
    type: String,
    default: ''
  },
  // Tax code
  tax_code: {
    type: String,
    default: ''
  },

  // モバイル決済の場合に使う一時的に保存する配送先
  temporary: {
    type: Boolean,
    default: false
  },

  // デフォルトの配送先かどうか。
  // 値は "shop", "subscription"
  is_default_for: {
    type: Array,
    default: []
  },
  // for wish list
  wishlist_flag: {
    type: Boolean,
    default: false
  },

  // 利用できるかどうか
  // 商品が配送できない地域等の場合に使用
  enable: {
    type: Boolean,
    default: true
  }
});

/**
 * @param {String} service - 'shop' or 'projects' (default value is 'shop')
 * @return {Object} Returns default shipping address used by the service passed by the argument
 */
Shipping.getCurrent = function (service = 'shop') {
  return Shipping.findOne((shipping) => {
    return shipping.is_default_for.includes(service);
  });
};

Shipping.formatOneLine = function (shipping) {
  let props;
  if (shipping.country === 'JP') {
    props = [
      'country_name',
      'zip',
      'state',
      'city',
      'line1',
      'line2',
      'name',
      'last_name',
      'first_name'
    ];
  } else {
    props = [
      'line1',
      'line2',
      'city',
      'state',
      'zip',
      'country_name',
      'name',
      'first_name',
      'last_name'
    ];
  }
  return props
    .filter((prop) => shipping[prop])
    .map((prop) => shipping[prop])
    .join(' ');
};

export default Shipping;
